import { Box, Modal } from "@mui/material";
import React from "react";
import * as yup from "yup";
import { CloseModalIcon } from "../../../../common/components/assets/commonassets/CommonAssets";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import PainAssessmentScale from "./assets/PainAssessmentScale.svg";
import { styled } from "@mui/material/styles";
import {
  successAlert,
  warningAlert,
} from "../../../../common/components/Toasts/CustomToasts";
import { IconButton, Slider, Tooltip } from "@mui/material";
import { useForm } from "react-hook-form";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import {
  addNewPainAssessmentReview,
  addNewPatientPainScore,
} from "../../../services/cliinicalChartServices/painAssesmentService/PainAssesmentService";
import InputField from "../../../../common/components/FormFields/InputField";
import { yupResolver } from "@hookform/resolvers/yup";
const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "90%",
  maxHeight: "80%",
  width: "65%",
  bgcolor: "background.paper",
  border: "1px solid gray",
  borderRadius: 4,
  //   overflowY: "scroll",
  boxShadow: 20,
  p: 2,
};
const CustomSlider = styled(Slider)({
  color: "#52af77",
  height: 8,
  padding: 7,

  "& .MuiSlider-mark": {
    border: "none",
    color: "gray",
    height: 7,
    // marginLeft: "2px",
  },
  "& .MuiSlider-rail": {
    border: "none",
    backgroundImage:
      "linear-gradient(.25turn,  lightblue, green, greenyellow, yellow, orange, red)",
  },
  "& .MuiSlider-track": {
    border: "none",
    backgroundImage:
      "linear-gradient(.25turn,  lightblue, green, greenyellow, yellow, orange, red)",
  },
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid blue",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&:before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: "black",
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&:before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
});
function valueText(value) {
  return `${value}°C`;
}
const sliderMarks = [
  {
    value: 0,
    scaledValue: 0,
  },
  {
    value: 1,
    scaledValue: 1,
  },
  {
    value: 2,
    scaledValue: 2,
  },
  {
    value: 3,
    scaledValue: 3,
  },
  {
    value: 4,
    scaledValue: 4,
  },
  {
    value: 5,
    scaledValue: 5,
  },
  {
    value: 6,
    scaledValue: 6,
  },
  {
    value: 7,
    scaledValue: 7,
  },
  {
    value: 8,
    scaledValue: 8,
  },
  {
    value: 9,
    scaledValue: 9,
  },
  {
    value: 10,
    scaledValue: 10,
  },
];
function ReviewOnPainAssessmentModal({
  openReviewPainAssement,
  handleClose,
  userActions,
  displayInfo,
  painId,
  menuId,
  populateTable,
}) {
  const defaultValues = {
    reviewRemark: ""
  }
  const schema = yup.object().shape({
    reviewRemark: yup.string().required("required")
  })
  const { control, register, handleSubmit, formState: { errors } } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
    defaultValues
  });
  const [privilege, setPrivilege] = React.useState(null);
  const [openPost, setOpenPost] = React.useState(false);
  const [painScore, setPainScore] = React.useState(0);
  const [reviewData, setReviewData] = React.useState([]);
  let selectedPainScore = 0;
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  let addedBy = userInfo?.userId;
  console.log("displayInfodisplayInfo", displayInfo);
  //   {
  //     "Bed No": "1003a",
  //     "Patient Name": "Mr. JAGDISH PRABHU SHINDE",
  //     "MRNo": "306815",
  //     "AdmissionId": 1071192,
  //     "AgeYear": "25 Y 10 M 19 D ",
  //     "DepartmentId": 117,
  //     "Department": "Anesthesia",
  //     "DoctorName": "kiya shinde",
  //     "TariffId": 2,
  //     "Discharged": false,
  //     "CompanyId": 0,
  //     "ClassId": 8,
  //     "PatientId": 2008117,
  //     "dob": "2000-04-05",
  //     "DoctorId": 41311,
  //     "IsBillGenerated": false,
  //     "BedId": 156,
  //     "isrecievebed": true,
  //     "IsNursingClearanceDone": false,
  //     "isTransferToWard": 1,
  //     "PrescriptionDate": "2025-07-16T18:30:00.000+00:00",
  //     "LockIndent": false,
  //     "CompanyName": null,
  //     "IsDischargeInitiated": true,
  //     "BedReleased": false,
  //     "AdmissionDate": "2025-04-04T18:30:00.000+00:00",
  //     "AllowToGO": false
  // }
  console.log("drrtrtrtrtrtrtrtrtrtrtrtr", errors);

  function onSubmitDataHandler(data) {
    console.log("painScorepainScore", painScore, privilege);

    let postObj = {
      addedBy: addedBy,
      admissionId: displayInfo?.AdmissionId,
      painAssessmentScore: Number(data?.painScore),
      menuId: menuId,
      privilege: "Create",
      painId: painId?.id,
      remarks: data?.reviewRemark
    };
    //
    setReviewData(postObj);
    setOpenPost(true);
  }
  const handleClosePost = () => setOpenPost(false);

  function addRecord() {
    console.log("reviewDatareviewDatareviewData", reviewData);

    addNewPainAssessmentReview(reviewData)
      .then((response) => response.data)
      .then((res) => {
        console.log("fsdfksjdhfjksdfsdfhjs", res);
        successAlert(res?.message);
        handleClosePost();
        populateTable();
        handleClose();
      });
  }
  return (
    <>
      <div>
        <Modal
          open={openReviewPainAssement}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={ModalStyle} className="min-w-[50%] max-w-[75%] rounded-md  ">
            <div className="flex gap-2 justify-between">
              <h4 className="text-sm 2xl:text-lg font-semibold whitespace-nowrap ">
                Pain Assessment Review
              </h4>
              <CloseModalIcon
                onClick={() => {
                  handleClose();
                }}
              />
            </div>

            <div className="mt-2 rounded-md border p-3 w-full bg-white">
              <div className="flex justify-center items-center w-full pb-2">
                <div className="text-sm 2xl:text-lg font-semibold whitespace-nowrap ">
                  <h4>Patient Pain Assessment</h4>
                </div>
              </div>
              <div className="flex space-x-2 w-full">
                <div className="flex flex-col  xl:mt-0 space-y-10 lg:space-y-8 xl:space-y-[52px]  2xl:space-y-[72px] xl:pt-0 2xl:pt-0 w-[25%] xl:w-[24%] text-xs 2xl:text-sm text-gray-600 whitespace-nowrap">
                  <h1 className="">Verbal Descriptor Scale</h1>
                  <h1 className="relative ">Wong-Baker Facial Grimace Scale</h1>
                  <h1 className="">Activity Tolerance Scale</h1>
                </div>
                <div className="w-[97%]">
                  <div className="w-full">
                    <img className="w-full" src={PainAssessmentScale} />
                  </div>
                  <div className="flex w-full justify-start mt-2">
                    <div className="w-[92%] xl:w-[90%] 2xl:w-[91%] ml-3 lg:ml-5 2xl:ml-9">
                      <CustomSlider
                        className="painScore"
                        control={control}
                        {...register("painScore")}
                        name="painScore"
                        onChange={(e, value) => setPainScore(value)}
                        aria-label="Custom marks"
                        value={painScore}
                        getAriaValueText={valueText}
                        min={0}
                        step={1}
                        max={10}
                        valueLabelDisplay="auto"
                        aria-labelledby="non-linear-slider"
                        style={{ height: "14px" }}
                        marks={sliderMarks}
                      />
                    </div>
                  </div>
                  <div className="w-80 pt-8">
                    <InputField control={control} name={"reviewRemark"} label={"Remarks"} placeholder="Remark" error={errors.reviewRemark}
                    />
                  </div>

                  <div className="flex justify-end space-x-4 mt-2 ">
                    {userActions.map((obj) => (
                      <>
                        {!obj.isAction && obj.action === "Create" ? (
                          <div
                            onClick={() => {
                              setPrivilege(obj?.action);
                            }}
                          >
                            <CommonButton
                              type="button"
                              className="bg-customGreen text-white"
                              label="Save"
                              onClick={handleSubmit(onSubmitDataHandler)}
                            />
                          </div>
                        ) : null}
                      </>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Modal>
        <ConfirmationModal
          confirmationOpen={openPost}
          confirmationHandleClose={handleClosePost}
          confirmationSubmitFunc={addRecord}
          confirmationLabel="Confirmation"
          confirmationMsg="Are you sure you want to submit a review for this?"
          confirmationButtonMsg="Submit"
        />
      </div>
    </>
  );
}
export default ReviewOnPainAssessmentModal;
